module.exports = __webpack_public_path__ + "media/images/instagram-a31b2bcd4e6e9c09d5d75ec63ce72d43.svg";